module.exports = __webpack_public_path__ + "store_instructions_full_1.png?eb660f93cd6fa90e0210706f89f829a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_instructions_full_1.png
// module id = 433
// module chunks = 0